<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.625 14.25L8 9.625L12.625 5" stroke="currentColor" stroke-width="0.925" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
